<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <img src="@/assets/images/icon/warning.png" alt="" />
        <div class="posi-title">{{ dataVal.title }}</div>
      </div>
      <div class="posi-over">
        {{ dataVal.content }}
      </div>

      <div class="posi-btn">
        <div class="hui" @click="handleClose">{{ dataVal.btn2 || "取消" }}</div>
        <div @click="handleSubmit">{{ dataVal.btn1 || "确认" }}</div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  name: "Popup",
  props: ["dataVal"],
  data() {
    return {
      flag: false,
    };
  },
  mounted() {},
  methods: {
    //提交
    handleSubmit() {
      if (!this.flag) {
        this.flag = true;
        let obj = {
          flag: false,
          submitFlag: true,
        };
        this.$emit("popupCell", obj);
        setTimeout(() => {
          this.flag = false;
        }, 2000);
      }
    },
    //关闭
    handleClose() {
      let obj = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("popupCell", obj);
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        this.flag = false;
      },
      deep: true,
    },
  },
};
</script>
  <style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
  
}
.posi-center {
  width: 400px;
  padding: 24px 32px 32px 32px;
  background-color: #fff;
  border-radius: 6px;
  /* Shadow/Shadow-3 上层投影 */
  box-shadow: 0px 6px 30px 5px rgba(0, 0, 0, 0.05),
    0px 16px 24px 2px rgba(0, 0, 0, 0.04), 0px 8px 10px -5px rgba(0, 0, 0, 0.08);
  .posi-head {
    // padding: 16px 16px 0;
    margin-bottom: 16px;
    @include flex-center(flex-start, center);
    img {
      width: 24px !important;
      height: 24px !important;
      object-fit: contain;
      margin-right: 8px;
    }
    .posi-title {
      font-size: 16px;
      font-weight: 700;
      color: #202224;
    }
    i {
      font-size: 28px;
      color: #606060;
      cursor: pointer;
    }
  }
  .posi-over {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.60);
    line-height: 22px;
  }
  .posi-btn {
    margin-top: 24px;
    @include flex-center(flex-end, center);
    div {
      width: 60px;
      height: 32px;
      color: #fff;
      background-color: #C12E30;
      font-size: 14px;
      @include flex-center(center, center);
      cursor: pointer;
      border-radius: 2px;
    }
    .hui {
      color: #fff;
      margin-right: 8px;
      background-color: #86909C;
    }
  }
}
</style>